import { graphql } from "@/api/graphql/types/gql.ts";

export const resynchronisationMutation = graphql(`
  mutation Resynchronise($request: MiddleMsResynchronisationRequest) {
    MiddleMsResynchronisation(request: $request) {
      requestId
    }
  }
`);
